import { Image } from 'expo-image';
import { StyleSheet, View } from 'react-native';

import { urnBlack } from '@/assets/images';
import { useColor } from '@/hooks/useColor';
import { i18n } from '@/utils/i18n';
import { actuatedNormalizeHorizontal, actuatedNormalizeVertical } from '@/utils/pixelScaling';

import Text from './Text';

const LoginHeader = () => {
  const colors = useColor();

  //Locales
  const brokenText = i18n.t('header.b')?.toUpperCase();
  const shepherdsText = i18n.t('header.s')?.toUpperCase();

  return (
    <View style={styles.header}>
      <Image source={urnBlack} style={styles.adaptiveIcon} contentFit="cover" tintColor={'black'} />
      <Text style={[styles.title, { color: colors.titleText }]} fontWeight="700">
        {brokenText}
      </Text>
      <Text style={[styles.title, { color: colors.titleText, marginTop: -15 }]} fontWeight="700">
        {shepherdsText}
      </Text>
    </View>
  );
};

export default LoginHeader;

const styles = StyleSheet.create({
  header: {
    justifyContent: 'center',
    alignItems: 'center',
    gap: 5,
    marginVertical: actuatedNormalizeVertical(20)
  },

  title: {
    fontSize: actuatedNormalizeHorizontal(28)
  },

  adaptiveIcon: {
    height: actuatedNormalizeVertical(80),
    width: actuatedNormalizeHorizontal(170)
  }
});
